// extracted by mini-css-extract-plugin
export default {"specificationsMain":"ShowSpecifications_specificationsMain__zQGJB","specificationsOther":"ShowSpecifications_specificationsOther__CHRYG"};